<script lang="ts" setup>
const modelValue = defineModel<boolean>({ default: false });

defineProps<{ disabled?: boolean }>();
</script>

<template>
  <label class="switch">
    <input
      v-model="modelValue"
      :disabled
      type="checkbox"
    />
    <span class="slider" />
  </label>
</template>

<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

  .slider {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 20px;
    background-color: $hell-black-20;
    cursor: pointer;
    transition: 0.3s;

    &::before {
      content: '';
      position: absolute;
      bottom: 3px;
      left: 3px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: $white;
      transition: 0.3s;
    }
  }

  input {
    width: 0;
    height: 0;
    opacity: 0;

    &:checked + .slider {
      background-color: $hell-green;

      &::before {
        transform: translateX(16px);
      }
    }

    &:disabled + .slider {
      cursor: not-allowed;
    }

    &:disabled + .slider::before {
      background-color: $hell-black-5;
    }
  }
}
</style>
